import type { Session } from '@/features/auth/types'
import { DEFAULT_BRAND_COLOR, DEFAULT_DISPLAY_NAME, DEFAULT_TERMS } from '@/types/workspace'

/** Only the optional development server predates the main workspace contract. */
export type DevelopmentSession = Omit<Session, 'workspace'> & { workspace?: Session['workspace'] }

export function developmentSession(value: DevelopmentSession): Session {
  if (!value.location) throw new Error('Die Entwicklungssitzung benötigt einen Standort.')
  return {
    ...value,
    workspace: value.workspace ?? {
      displayName: value.organization?.name ?? DEFAULT_DISPLAY_NAME,
      brandColor: DEFAULT_BRAND_COLOR,
      logoUrl: null,
      terms: structuredClone(DEFAULT_TERMS),
    },
  }
}
